@if (userName) {
  <div class="no-rights">
    <div class="no-rights__header">
      <b>{{ 'NoRightsPage.NoSufficientRights' | translate }}</b>
    </div>
    <div class="no-rights__content">
      <b>{{ userName }}</b>
      {{ 'NoRightsPage.NoSufficientRightsContent' | translate }}
    </div>
    <div class="no-rights__actions">
      <dv-button color="secondary" (click)="onOkClick()">
        {{ 'General.Ok' | translate | uppercase }}
      </dv-button>
    </div>
  </div>
}
